import { Component } from '@angular/core';

@Component({
    selector: 'app-activity-create',
    templateUrl: './activity-create.component.html',
    styleUrls: ['./activity-create.component.scss'],
    standalone: false
})
export class ActivityCreateComponent {}
